export const StockReportColumns = [
  { title: "Product", dataIndex: "product" },
  { title: "Qty", dataIndex: "qty" },
  { title: "Orders#", dataIndex: "orders" },
];

export const SuburbReportColumns = [
  { title: "Order#", dataIndex: "orderNumber" },
  { title: "Customer", dataIndex: "customerName" },
  { title: "Phone", dataIndex: "phone" },
  { title: "Address", dataIndex: "shipAdd1" },
];
